import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-cms-subject",
  "use": "icon-cms-subject-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-cms-subject\"><path d=\"M147.2 489.6l73.6-44.8 291.2 176 291.2-176 73.6 44.8L512 710.4 147.2 489.6z m0-144L512 147.2l364.8 198.4L512 544 147.2 345.6zM512 787.2l291.2-176 73.6 44.8L512 876.8 147.2 656l73.6-44.8 291.2 176z\" p-id=\"6147\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/cms-subject.svg
// module id = zjZS
// module chunks = 45